import { useCallback } from 'react'
import { useLoading, useServerError } from 'shared/hooks'
import { useConfirmProductChartMatchMutation } from '../graphql/mutations/confirmProductChartMatch.types'
import { useGetProductChartMatchListQuery } from '../graphql/queries/getProductChartMatchList.types'

export const useProductChartMatch = () => {
  const [mutate, { error: confirmMatchError, loading: confirmMatchLoading }] = useConfirmProductChartMatchMutation({
    update(cache) {
      cache.modify({
        fields: {
          getProductChartMatchList() {}
        }
      })
    }
  })

  const confirmProductChartMatch = useCallback(
    async (id: string) => {
      await mutate({ variables: { id } })
    },
    [mutate]
  )

  const {
    loading: isLoading,
    data,
    error: productChartMatchError
  } = useGetProductChartMatchListQuery({
    notifyOnNetworkStatusChange: true
  })

  useLoading({ isLoading: isLoading || confirmMatchLoading  })
  useServerError([productChartMatchError, confirmMatchError])

  return { confirmProductChartMatch, productChartMatchList: data?.getProductChartMatchList.items }
}
